import { Config } from '@leverege/plugin';
import { MapControl } from '@leverege/ui-mapbox-elements';
import I18N from '@leverege/i18n';
const {
  t
} = I18N.ns('molten.dataViewers.map.ZoomOut');
export default {
  id: 'molten.mapDataViewer.ZoomOut',
  matches: {
    use: 'bottomRightActionBar',
    client: ['MapDataViewer', 'GoogleMapsDataViewer']
  },
  layout: {
    sort: 'aZoomB'
  },
  handles: context => {
    const {
      streetView
    } = context;
    return !streetView;
  },
  appearance: () => {
    return {
      name: t('name'),
      prefer: 'icon',
      icon: Config.get('MapScreen', 'zoomOutIcon', 'https://storage.googleapis.com/molten-ui-assets/icon-zoom-out.png')
    };
  },
  perform: ({
    context
  }) => {
    const {
      clientProps
    } = context;
    MapControl.zoomOut(clientProps.mapName || 'map');
  }
};